




























import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import store from './store';
import Grid from './components/Grid.vue';
import Welcome from './components/Welcome.vue';
import Banner from './components/Banner.vue';
import Footer from './components/Footer.vue';
import Connect from './components/Connect.vue';
import Profile from './components/Profile.vue';
import Privacy from './components/Privacy.vue';
import Terms from './components/Terms.vue';
import ResetPassword from './components/ResetPassword.vue';

const state: any = store.state;

axios.interceptors.request.use(
  config => {
    // Get auth token from store
    const user = state.profile.user;
    if (user != undefined && user.token != undefined) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

@Component({
  components: {
    Banner,
    Connect,
    Profile,
    Grid,
    Welcome,
    Footer,
    Privacy,
    Terms,
    ResetPassword,
  },
})

export default class App extends Vue {
  private signedIn: string = '';

  private async getCanvasData() {
    const gridComponent: any = this.$refs.gridComponent;
    gridComponent.getUserData();
    const profileComponent: any = this.$refs.profileComponent;
    profileComponent.setOrgInfo();
    profileComponent.setProfileInfo();
  }

  private setCurPage(newPage: string) {
    if (newPage !== this.$route.name) {
      this.$router.push({ name: newPage });
      const bannerComponent: any = this.$refs.bannerComponent;
      bannerComponent.updatePage(newPage);
    }

  }

  private setSignedInState(newState: string) {
    this.signedIn = newState;
    const bannerComponent: any = this.$refs.bannerComponent;
    store.state.signedIn = true;
    bannerComponent.cSignedIn = this.signedIn;
    bannerComponent.updatePage('Canvas');
  }

  private getCurPage() {
    return this.$route.name;
  }

  private signOut() {
    this.signedIn = '';
    const bannerComponent: any = this.$refs.bannerComponent;
    bannerComponent.cSignedIn = this.signedIn;
    this.setCurPage('Connect');

  }
}
